import httpService from '../../../../services/httpService';

export interface AttendanceScheduleParams {
  session_name?: string;
  offset_time?: string;
  round_id?: string;
}

export interface AttendanceUserParams {
  page_number?: number;
  limit?: number;
  name?: string;
  offset_time?: string;
  email_address?: string;
  status?: string;
  session_id?: string;
}

const getOffsetTime = () => {
  const offset = new Date().getTimezoneOffset();
  const sign = offset > 0 ? '-' : '+';
  const abs = Math.abs(offset);
  return `${sign}${String(Math.floor(abs / 60)).padStart(2, '0')}:${String(abs % 60).padStart(2, '0')}`;
};

const ResultsClient = {
  /**
   * Fetch attendance data for interview schedules.
   */
  getSchedulesAttendance: async (params?: AttendanceScheduleParams) => {
    const finalParams = { ...params, offset_time: getOffsetTime() };
    const response = await httpService.get("/interview_admin/attendance", { params: finalParams });
    return response.data;
  },

  /**
   * Fetch users for a specific schedule/attendance list.
   */
  getScheduleUsers: async (params?: AttendanceUserParams) => {
    const finalParams = { ...params, offset_time: getOffsetTime() };
    const response = await httpService.get("/attendance/users", { params: finalParams });
    return response.data;
  },

  /**
   * Fetch feedback for a specific session.
   * This endpoint should match what the feedback page expects.
   */
  getFeedback: async (sessionId: string, candidateId: string) => {
    const response = await httpService.get(`/interview/feedback`, { params: { session_id: sessionId, candidate_id: candidateId } });
    return response.data;
  },

  getReport: async (sessionId: string, candidateId: string, includeTranscript: boolean) => {
    const response = await httpService.get(`/interview/report`, { 
      params: { 
        session_id: sessionId, 
        transcript_attached: includeTranscript, 
        candidate_id: candidateId 
      } 
    });
    return response.data;
  },

  getProctoringReport: async (sessionId: string, candidateId: string) => {
    const response = await httpService.get(`/proctor/report`, { params: { session_id: sessionId, candidate_id: candidateId } });
    return response.data;
  },

  getProctoringData: async (sessionId: string, candidateId: string) => {
    const response = await httpService.get(`/proctor/data`, { params: { session_id: sessionId, candidate_id: candidateId } });
    return response.data;
  },

  /**
   * Fetch sessions for a particular user across all schedules.
   */
  getUserSessions: async (candidateId: string) => {
    const response = await httpService.get(`/interview/sessions`, { 
      params: { candidate_id: candidateId, offset_time: getOffsetTime() } 
    });
    return response.data;
  }
};

export default ResultsClient;
